<div class="spb-holder">
  @if (loanService.application()) {
    <div class="spb-content-holder">
      <!-- Title and edition buttons -->
      <div class="header">
        <div class="title-holder">
          <button (click)="location.back()" matIconButton>
            <mat-icon>keyboard_backspace</mat-icon>
          </button>

          <div [style.margin-right.px]="10">Lånelöfte</div>
          <spb-status-indicator [loanPromise]="loanService.application()!"/>
        </div>

        <!-- Buttons - Only shown if the application is not issued -->

        <div class="header-buttons">
          @if (helper.canAdminClassic()) {
            <button matButton="filled" (click)="addNote()">
              <mat-icon>description</mat-icon>
              Anteckna
            </button>

            <!-- Decline loan - Only visible if it is not already declined -->
            @if (loanService.application()?.status !== 'declined' && loanService.application()?.status !== 'manually_issued' && loanService.application()?.status !== 'approved') {
              <button matButton="filled" (click)="declineLoan()">
                <mat-icon>do_not_disturb_on</mat-icon>
                Avslå lånelöfte
              </button>
            }

            <!-- Issue loan - Only visible if approved or rejected -->
            @if (loanService.application()?.status === 'issuable') {
              <button matButton="filled" (click)="issueLoan()">
                <mat-icon>request_quote</mat-icon>
                Bevilja lånelöfte
              </button>
            }
            <!-- Re run UC - Only visible if pending -->
            @if (loanService.application()?.status !== 'approved' && loanService.application()?.status !== 'manually_issued' && loanService.application()?.status !== 'declined') {
              <button matButton="filled" (click)="reRunUc()">
                <mat-icon>person_search</mat-icon>
                UC Kontroll
              </button>
            }
            <!-- Edit - Only shown if the application is not issued -->
            @if (loanService.application()?.status !== 'approved' && loanService.application()?.status !== 'manually_issued' && loanService.application()?.status !== 'declined') {
              <button matButton="filled"
                      (click)="startEditing()">
                <mat-icon>edit</mat-icon>
                Ändra uppgifter
              </button>
            }
          }
          <!-- Loan Document - Only shown if the application is issued and has document -->
          @if ((loanService.application()?.status === 'approved' || loanService.application()?.status === 'manually_issued')) {
            <button matButton="filled" (click)="openDocument()">
              <mat-icon>open_in_new</mat-icon>
              Lånelöfte
            </button>
          }
        </div>

      </div>

      <div class="holder">
        <!-- Assigned admin -->
        <p>
          @if (loanService.application()?.adminData?.assignee; as assignee) {
            Tilldelad: {{ assignee }}
          } @else {
            Inte tilldelad
          }
        </p>

        <spb-kalp-non-superfast-info/>

        <spb-kalp-status-progress/>

        <spb-kalp-logs/>


        <!-- Basic information (Grunduppgifter) -->
        <spb-kalp-basic-info/>

        <!-- New property (Bostaden) -->
        <spb-kalp-new-property/>

        <!-- Loan costs (Lånekostnader) -->
        <spb-kalp-loan-costs/>

        <!-- Old property (Existerande bostad) -->
        <spb-kalp-old-property/>

        <!-- Tax reduction (Ränteavdrag) -->
        <spb-kalp-tax-reduction/>

        <!-- KALP -->
        <spb-kalp-kalp-info/>

        <!-- UC -->
        <spb-kalp-uc-info/>
      </div>
    </div>
  }
</div>
